import { ComponentProps, FC, Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EIconSize } from 'utils/constants/app/ui';
import { lazy } from 'utils/generic/lazy';
import { SearchElementSkeleton } from 'newelements/SearchElement/Skeleton';
import { GlobalIcon } from 'components/GlobalIcon';
import { Popup } from 'components/Popup';
import { useCalculateBetslipFixedSwitchersHeight } from 'hooks/betslip/useCalculateBetslipFixedSwitchersHeight';
import { isMobile } from '../../utils/is-mobile';

const { SearchElementComponent } = lazy(
  () =>
    import(
      /* webpackChunkName: "search-element-internal-lazy-component" */ './Component'
    )
);

export const SearchElement: FC<
  ComponentProps<typeof SearchElementComponent>
> = props => {
  const { t } = useTranslation();
  const [openPopup, setOpenPopup] = useState(false);
  const bottomNavigationHeight = useCalculateBetslipFixedSwitchersHeight();

  return props.configs?.searchLayout && isMobile() ? (
    <>
      <div className="search__icon">
        <GlobalIcon
          lib="generic"
          name="search"
          theme="default"
          size={EIconSize._14}
          onClick={() => {
            setOpenPopup(true);
          }}
        />
      </div>
      {openPopup && (
        <Popup
          open
          style={{
            zIndex: '6',
            top: '0',
            height: `calc(100% - ${bottomNavigationHeight}px)`
          }}
          className="search__popup"
        >
          <div className="search__header">
            <div className="search__header__title">{t('account.search')}</div>
            <span
              className="search__header__close"
              onClick={() => {
                setOpenPopup(false);
              }}
            >
              {t('account.close')}
            </span>
          </div>
          <Suspense fallback={<SearchElementSkeleton />}>
            <SearchElementComponent {...props} />
          </Suspense>
        </Popup>
      )}
    </>
  ) : (
    <Suspense fallback={<SearchElementSkeleton />}>
      <SearchElementComponent {...props} />
    </Suspense>
  );
};
